import React from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/Add';
import { Box, Card, IconButton } from '@mui/material';

const AddEcosystem = ({ onClick }) => (
  <Card
    className="item"
    onClick={onClick}
    sx={{
      minHeight: 300,
      border: '1px dashed #d0d4d6',
      borderRadius: '4px',
      backgroundColor: '#fff',
      boxShadow: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'box-shadow 150ms ease',
      '&:hover': {
        boxShadow: '0 5px 10px -2px rgba(136, 136, 136, 0.2)',
      },
    }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <IconButton
        sx={{
          minWidth: 52,
          width: 52,
          height: 52,
          borderRadius: '50%',
          padding: 0,
          lineHeight: 1,
          color: '#fff',
          backgroundColor: '#BE53D2',
          boxShadow: '8px 8px 16px 0px rgba(190, 83, 210, 0.45)',
          '&:hover': {
            backgroundColor: '#BE53D2',
            boxShadow: '8px 8px 12px rgba(190, 83, 210, 0.5)',
          },
        }}
      >
        <AddIcon sx={{ fontSize: 35 }} />
      </IconButton>
      <Box
        sx={{
          mt: 2,
          fontSize: 22,
          lineHeight: 1,
          color: '#241539',
        }}
      >
        Add New
      </Box>
    </Box>
  </Card>
);

AddEcosystem.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default AddEcosystem;
